import { MatchViewModel } from './mapper/mapToMatchViewModel';

export async function saveMatchData(matchViewModel: MatchViewModel) {
    // do something else if localhost (local testing)
    if (window.location.host.includes('localhost')) {
        console.log(JSON.stringify(matchViewModel));
        console.log('Save match data skipped due to localhost.');
        return new Response(JSON.stringify({ message: 'Localhost detected. No match data fetched.' }));
    }
    const response = await fetch('https://bct-scoreboard-v2.taegener.eu/web/access/save_match_data.php', {
        mode: 'cors',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
            match_kind: matchViewModel.mode_string,
            data: JSON.stringify(matchViewModel),
        }),
    });
    if (!response.ok) {
        throw new Error('Error saving match data. HTTP status: ' + response.status);
    }
    console.info('[MatchController.ts] Match saved successfully.');
    return response;
}